import { css } from 'styled-components';

/** Disable infinite animations on mobile — biggest scroll-jank win on phones */
export const pauseAnimationsOnMobile = css`
  @media (max-width: 768px) {
    animation: none !important;
  }
`;

export const pauseAnimationsOnMobileExcept = (selector) => css`
  @media (max-width: 768px) {
    & ${selector} {
      animation: none !important;
    }
  }
`;

export const respectReducedMotion = css`
  @media (prefers-reduced-motion: reduce) {
    animation: none !important;
    transition-duration: 0.01ms !important;
  }
`;

/** backdrop-filter is very expensive on mobile GPUs */
export const solidGlassOnMobile = css`
  @media (max-width: 768px) {
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    background: rgba(12, 10, 24, 0.88);
  }
`;

export const hideOnMobile = css`
  @media (max-width: 768px) {
    display: none;
  }
`;
